module.exports = __webpack_public_path__ + "img/sl.2b040d07.svg";